import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class BeneficialOwnerHistoryResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.beneficialOwnerHistoryId = "";
        this.isActualBeneficialOwner = false;
    }
    pk() {
        return `BOhistory_` + this.beneficialOwnerHistoryId;
    }
    static listUrl(allParams = {}) {
        const { customerId } = allParams;
        if (customerId !== undefined) {
            return `${this.urlRoot}/history/${customerId}`;
        }
        throw new Error("BeneficialOwnerHistoryResource requires customerId");
    }
}
BeneficialOwnerHistoryResource.urlRoot = apiResourceUrl("beneficial-owner-v2/");
BeneficialOwnerHistoryResource.urlTemplates = [
    `${BeneficialOwnerHistoryResource.urlRoot}/history/{customerId}`
];
//# sourceMappingURL=BeneficialOwnerHistoryResource.js.map